<template>
  <a :href="broadcast.url"
     class="bx-epg-broadcast"
     :class="{ 'bx-epg-broadcast--on-air': onAir }">
    <figure v-if="broadcast.image">
      <img :src="thumbnailUrl"
           :alt="`${broadcast.title} Thumbnail`"
           loading="lazy"
           @error="onImageError">
    </figure>
    <div>
      <div>
        <span>{{ broadcast.categoryName }}</span>
        <span>{{ broadcast.genreName }}</span>
      </div>
      <div>{{ broadcast.title }}</div>
      <div>
        <div v-if="onAir"
             :style="{ width: progress + '%' }" />
      </div>
      <div>
        <span>{{ formatTime(broadcast.airTime) }}-{{ formatTime(broadcast.airTimeEnd) }}</span>
        <VodEpgBadges :badges="broadcast.flags"
                      :inline-usage="true" />
        <div v-if="showPlayIcon"
             class="bx-badges bx-badges--below-teaser-content">
          <svg class="bx-badge bx-badge--video icon icon-play">
            <use href="/images/icon_sprite.svg#play" />
          </svg>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import { format } from 'date-fns-tz'
import { mapState } from 'pinia'

import epgAirTimeHelper from '../mixins/epg-air-time-helper'
import imgSrcSet from '../../../../mixins/img-src-set'
import VodEpgBadges from '../../../../components/shared/vod-epg/Badges.vue'
import { useConfigStore } from '../../../../stores/config'
import { usePageStore } from '../../../../stores/page.js'

export default {
  components: {
    VodEpgBadges
  },
  mixins: [epgAirTimeHelper, imgSrcSet],
  props: {
    broadcast: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      progress: -1, // -1 means not yet calculated
      onAir: false // true if the broadcast is currently on air
    }
  },
  computed: {
    ...mapState(usePageStore, ['brandFromStore']),
    // this store prop is only used by a mixin
    ...mapState(useConfigStore, ['rsConfig']),
    showPlayIcon () {
      return this.broadcast.hasAutoPlay
    },
    thumbnailUrl () {
      return this.createImgSrc({
        image: this.broadcast.image,
        brand: this.brandFromStore,
        width: 75,
        setName: 'broadcastThumbnail',
        type: 'webp'
      })
    }
  },
  mounted () {
    this.updateProgress()
  },
  methods: {
    formatTime (timestamp) {
      const date = new Date(timestamp)

      // explicitly convert to our timezone to ensure consistent display
      // example: a request from san francisco (google) won't be 11:15 am but 20:15 - https://bauerxcel.atlassian.net/browse/NXT-8158
      const airTime = this.forceDateIntoTimeZone(date)

      return format(airTime, 'HH:mm')
    },
    updateProgress () {
      const now = Date.now()
      const start = new Date(this.broadcast.airTime).getTime()
      const end = new Date(this.broadcast.airTimeEnd).getTime()

      this.progress = now < start
        ? 0
        : now >= end
          ? 100
          : ((now - start) / (end - start)) * 100

      this.onAir = now >= start && now <= end
    },
    onImageError (event) {
      event.target.src = '/images/tvmovie/epgThumbnailFallback.jpeg'
    }
  }
}
</script>
